// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AccountBookTwoToneSvg from "@fishx/icons-svg/es/asn/AccountBookTwoTone";
import FishxIcon from '../components/FishxIcon';

var AccountBookTwoTone = function AccountBookTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AccountBookTwoToneSvg
  }));
};

AccountBookTwoTone.displayName = 'AccountBookTwoTone';
export default React.forwardRef(AccountBookTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AccountBookTwoTone.js
// module id = 1946
// module chunks = 0